const US_TIMEZONE_DATA = [
  { name: 'US/PACIFIC', zone: 'PACIFIC', offset: -8 },
  { name: 'US/MOUNTAIN', zone: 'MOUNTAIN', offset: -7 },
  { name: 'US/CENTRAL', zone: 'CENTRAL', offset: -6 },
  { name: 'US/EASTERN', zone: 'EASTERN', offset: -5 },
  { name: 'US/ALASKA', zone: 'ALASKA', offset: -9 },
  { name: 'US/HAWAII', zone: 'HAWAII', offset: -10 }
];

const formatOffset = offset => `GMT${offset >= 0 ? '+' : ''}${offset}:00`;
const TIMEZONE_ABBREVIATIONS = {
  PACIFIC: 'PST',
  MOUNTAIN: 'MST',
  CENTRAL: 'CST',
  EASTERN: 'EST',
  ALASKA: 'AKST',
  HAWAII: 'HST'
};

const getInitials = zoneName => TIMEZONE_ABBREVIATIONS[zoneName] || `${zoneName[0]}ST`;
const formatTitle = zoneName => zoneName.charAt(0) + zoneName.slice(1).toLowerCase();

export const getTimezones = () => {
  return US_TIMEZONE_DATA.map(data => ({
    name: data.name,
    title: `${formatTitle(data.zone)} Time`,
    offset_title: formatOffset(data.offset),
    offset: data.offset,
    initials: getInitials(data.zone)
  }));
};
